<template>
  <div class="main" v-title data-title="北京天蔚中医药发展促进中心-项目展示">
    <div class="swipe">
      <img src="http://123.56.170.62:9999/static/bg/banner8.png" alt />
    </div>
    <div class="program">
      <div class="showSomeProgram">
        <div class="pwrapper">
          <div class="allProgram">
            <div
              :style="
                pcurrentIndex == 0
                  ? ''
                  : pcurrentIndex == Math.ceil(pnav.length / 4) - 1
                  ? `left:${-6.42 * (pcurrentIndex - 1) -
                      (6.42 / 4) * (pnav.length % 4)}rem`
                  : `left:${-6.42 * pcurrentIndex}rem`
              "
              class="showProgram"
            >
              <div
                class="pContent"
                :style="
                  realPcurrentIndex == index
                    ? 'color:#ff7233;border-bottom-width:0.04rem'
                    : ''
                "
                v-for="(item, index) in pnav"
                :key="index"
              >
                <img ref="imghead" :src="item.picture" alt />
                <p
                  :style="realPcurrentIndex == index ? 'color:#ff7233' : ''"
                  @click="ptoLink(item, index)"
                >
                  {{ item.name }}
                </p>
              </div>
            </div>
          </div>
          <!-- <div :style="`left:${1.62*pscurrentIndex+0.26+0.04*pcurrentIndex}rem`" class="pnavline"></div> -->
          <div
            :style="pcurrentIndex == 0 ? 'display:none;' : ''"
            @click="ptoLeft"
            v-if="pnav.length > 4"
            class="pLeft el-icon-arrow-left"
          ></div>
          <div
            :style="
              pcurrentIndex == Math.ceil(pnav.length / 4) - 1
                ? 'display:none;'
                : ''
            "
            @click="ptoRight"
            v-if="pnav.length > 4"
            class="pRight el-icon-arrow-right"
          ></div>
        </div>
        <div class="pLine"></div>
        <div class="video" v-if="programData.video">
          <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            @pause="pausePlay($event)"
            :options="playerOptions"
          ></video-player>
        </div>
        <div class="pabs">
          <h2>{{ programData.name }}</h2>
          <h4>
            <span>{{ programData.itemtime }}</span>
            <span>浏览量 : {{ programData.itmecount }}</span>
          </h4>
          <div class="pabsContent" v-html="programData.richtext"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProgram, getDetailData } from "@/api/product.js"
import { BASE_URL } from "@/utils/base.js"
import { videoPlayer } from "vue-video-player"
import objectFitImages from "object-fit-images"
export default {
  name: "Home",
  data() {
    return {
      pnav: [],
      pcurrentIndex: 0,
      realPcurrentIndex: 0,
      pscurrentIndex: 0,
      programData: {},
      playerOptions: {
        //播放速度
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: "auto",
        language: "zh-CN",
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: "16:9",
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [
          {
            //类型
            type: "video/mp4",
            //url地址
            src: "",
          },
        ],
        //你的封面地址
        poster: "",
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true,
        },
      },
    }
  },
  async created() {
    await this.getProgram()
    if (this.$route.params.id) {
      this.getProgramDetail(this.$route.params.id)
    } else {
      this.getProgramDetail(this.pnav[0].id)
    }
    if (this.$route.params.index) {
      this.realPcurrentIndex = this.$route.params.index
    }
  },
  mounted() {
    window.scrollTo({
      top: 0,
    })
    objectFitImages(this.$refs.imghead)
  },
  methods: {
    // 获取项目
    async getProgram() {
      let program = await getProgram()
      this.pnav = program.filter((item) => {
        item.itemtime = item.itemtime.substring(0, 10)
        return (item.picture = BASE_URL + item.picture)
      })
    },
    pausePlay(player) {
      //关闭弹窗-停止播放
      this.player.pause()
    },
    // 获取项目内容
    async getProgramDetail(id) {
      let p = new FormData()
      p.append("id", id)
      let program = await getDetailData(p)
      this.programData = program
      this.programData.itemtime = this.programData.itemtime.substring(0, 10)
      this.programData.picture = BASE_URL + this.programData.picture
      if (this.programData.video) {
        this.programData.video = BASE_URL + this.programData.video
        this.playerOptions.sources[0].src = this.programData.video
      }
    },
    // 进入项目详情
    ptoLink(item, index) {
      this.realPcurrentIndex = index
      this.getProgramDetail(item.id)
      if (this.pcurrentIndex == Math.ceil(this.pnav.length / 4) - 1) {
        this.pscurrentIndex = 4 - this.pnav.length + index
      } else {
        this.pscurrentIndex = index % 4
      }
    },
    // 点击切换
    ptoLeft() {
      if (this.pcurrentIndex == 0) {
        this.pcurrentIndex = 0
      } else {
        this.pcurrentIndex--
      }
    },
    ptoRight() {
      if (this.pcurrentIndex == Math.ceil(this.pnav.length / 4) - 1) {
        this.pcurrentIndex = Math.ceil(this.pnav.length / 4) - 1
      } else {
        this.pcurrentIndex++
      }
    },
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    },
  },
  components: { videoPlayer },
}
</script>
<style lang="less" scoped>
.main {
  width: 100%;
  .swipe {
    width: 100%;
    img {
      width: 100%;
      height: 400px;
    }
  }
  .program {
    padding-bottom: 42px;
    width: 100%;
    background-color: #fff;
    .showSomeProgram {
      width: 854px;
      margin: 40px auto;
      text-align: center;
      .pwrapper {
        width: 648px;
        margin: 0 auto;
        height: 150px;
        position: relative;
        .pnavline {
          width: 110px;
          height: 4px;
          background-color: #fe7333;
          position: absolute;
          transition: 0.3s all linear;
          left: 0;
          bottom: -10px;
        }
        .allProgram {
          width: 648px;
          height: 150px;
          margin: 0 auto;
          overflow: hidden;
          position: relative;
          .showProgram {
            position: absolute;
            left: 0;
            top: 0;
            width: 3000px;
            display: flex;
            justify-content: flex-start;
            transition: 0.5s linear all;
            .pContent {
              width: 110px;
              margin: 0px 26px;
              text-align: center;
              border-bottom: 0px solid #fe7333;
              padding-bottom: 10px;
              img {
                width: 90px;
                object-fit: cover; //object-fit-images
                font-family: "object-fit: cover;";
                height: 90px;
                border-radius: 50%;
                margin-bottom: 10px;
              }
              p {
                color: #000;
                font-size: 14px;
                line-height: 1.3;
                cursor: pointer;
              }
            }
          }
        }
        .pLeft {
          position: absolute;
          left: -36px;
          top: 60px;
          font-size: 24px;
          cursor: pointer;
        }
        .pRight {
          position: absolute;
          right: -36px;
          top: 60px;
          font-size: 24px;
          cursor: pointer;
        }
      }
      .pLine {
        width: 100%;
        height: 2px;
        margin: 0;
        background-color: #f5f5f5;
      }
      .video {
        margin: 30px auto 0;
        width: 480px;
        height: 270px;
      }
      .pabs {
        width: 620px;
        margin: 60px auto 0;
        display: flex;
        flex-direction: column;
        font-size: 14px;
        color: #000;
        h2 {
          font-size: 24px;
          color: #000;
          text-align: center;
          margin-bottom: 30px;
        }
        .pabsContent {
          text-align: left;
          line-height: 2;
        }
        h4 {
          display: flex;
          margin-bottom: 20px;
          justify-content: flex-end;
          span {
            margin-right: 10px;
          }
        }
      }
    }
  }
}
</style>
